<script setup>
const props = defineProps({
  progress: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["previous-block"]);

// Handle previous button click
const handlePrevious = () => {
  emit("previous-block");
};
</script>

<template>
  <div class="relative flex flex-col items-center justify-center h-full">
    <video
      class="bg-black w-[175px] h-[175px] object-cover object-center rounded-full mb-lg"
      autoplay
      loop
      muted
      playsinline
    >
      <source
        src="https://res.cloudinary.com/hello-sunshine/video/upload/w_500,h_500,c_fill,q_auto,f_mp4/v1746189095/641721_Cyber_Green_Binary_Code_Interface_By_Oksana_Kumer_Artlist_HD.mp4"
        type="video/mp4"
      />
    </video>

    <div class="flex flex-col items-center flex-grow">
      <div class="font-bold text-3xl pb-md">Even geduld ...</div>
      <p>
        Onze servers zijn druk bezig met het ontcijferen van de Da Vinci Code
        ... Oh nee, wacht, de WCAG 2.1 AA checks. Bijna klaar!
      </p>
    </div>
  </div>
</template>
